import { Injectable, inject } from "@angular/core";
import { Observable, of } from "rxjs";
import { map, shareReplay, tap } from "rxjs/operators";
import { FeatureDTO } from "../models/common/FeatureDTO";
import { IFeature } from "../models/feature-models";
import { ApiClientService } from "../services/api-client.service";

@Injectable({
    providedIn: "root"
})
export class FeatureService {
    features$: Observable<FeatureDTO[]>;

    private readonly apiClientService = inject(ApiClientService);

    getFeatureActive(featureName: string): Observable<boolean> {
        return this.isActive(featureName, true);
    }

    getMenuOptionActive(featureNameActive: string, featureNameInactive: string = null): Observable<boolean> {
        if(featureNameInactive) {
            return this.isActive(featureNameInactive, false);
        }
        return this.isActive(featureNameActive, true);
    }

    initFeatures(features: FeatureDTO[]): void {
        this.features$ = of(features);
    }

    refreshClientFeatures() {
        this.features$ = this.apiClientService.get<IFeature[]>("feature/getClientFeatures").pipe(shareReplay(1));
    }

    private getFeatures(): Observable<FeatureDTO[]> {
        if (this.features$ == null) {
            this.features$ = this.apiClientService.get<FeatureDTO[]>("feature", false).pipe(
                shareReplay(1)
            );
        }
        return this.features$;
    }

    private isActive(featureName: string, activeStatus: boolean): Observable<boolean> {
        return this.getFeatures().pipe(
            tap(features => {
                if(!features.some(feature => feature.name === featureName)) {
                    console.error(`Feature ${  featureName  } som försöker användas saknas ibland tillgängliga features!`);
                }
            }),
            map(res => res.some(r => r.active === activeStatus && r.name === featureName))
        );
    }
}
